export default __webpack_public_path__ + "static/media/proyecto_img-removebg.ef9ca83b.png";